import React from "react";
import Svg, { Path } from "react-native-svg";

const ShippingIcon = ({ size = 50 }) => {
  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 46 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M22.1033 0.816987C22.4701 0.0737413 23.5299 0.0737396 23.8967 0.816985L30.1146 13.4158C30.2603 13.711 30.5419 13.9156 30.8676 13.9629L44.7713 15.9832C45.5915 16.1024 45.919 17.1104 45.3255 17.6889L35.2647 27.4957C35.029 27.7255 34.9214 28.0565 34.9771 28.3809L37.3521 42.2284C37.4922 43.0453 36.6348 43.6682 35.9012 43.2825L23.4653 36.7446C23.174 36.5915 22.826 36.5915 22.5347 36.7446L10.0988 43.2825C9.36521 43.6682 8.50778 43.0453 8.64789 42.2284L11.0229 28.3809C11.0786 28.0565 10.971 27.7255 10.7353 27.4957L0.674537 17.6889C0.0810206 17.1104 0.40853 16.1024 1.22875 15.9832L15.1324 13.9629C15.4581 13.9156 15.7397 13.711 15.8854 13.4158L22.1033 0.816987Z"
        fill="#FFB800"
      />
    </Svg>
  );
};

export default ShippingIcon;
